import { z } from 'zod';

export const USER_PROFILE_VALIDATOR = z
    .object({
        FirstName: z.string({ required_error: 'First name is required' }).min(1, { message: 'First name is required' }),

        LastName: z.string({ required_error: 'Last name is required' }).min(1, { message: 'Last name is required' }),

        Email: z
            .string({ required_error: 'Email is required' })
            .min(1, { message: 'Email is required' })
            .email({ message: 'Invalid email format. Example: user@example.com' }),

        PhoneNumber: z
            .string({ required_error: 'Phone number is required' })
            .min(1, { message: 'Phone number is required' })
            .regex(/^[2-9]\d{2}[2-9]\d{2}\d{4}$/, 'Please enter a valid phone number')
    })
    .passthrough();

export const USER_ADDRESS_VALIDATOR = z
    .object({
        businessType: z.string().optional(),

        Name: z.string().optional(),

        FirstName: z.string().optional(),

        LastName: z.string().optional(),

        Line1: z.string({ required_error: 'Address is required' }).min(1, 'Address is required'),

        Country: z.string({ required_error: 'Country is required' }).min(1, 'Country selection is required'),

        State: z.string({ required_error: 'Province is required' }).min(1, 'Province is required'),

        City: z.string({ required_error: 'City is required' }).min(1, 'City is required'),

        PostCode: z
            .string({ required_error: 'Postal code is required' })
            .min(1, 'Postal code is required')
            .regex(/^[0-9A-Za-z\s-]+$/, 'Invalid postal code format')
    })
    .passthrough()
    .superRefine((data, ctx) => {
        console.log('data', data);
        if (data.businessType === 'smallBusiness') {
            if (!data?.Name?.trim()) {
                ctx.addIssue({
                    path: ['Name'],
                    message: 'Legal business name is required',
                    code: z.ZodIssueCode.custom
                });
            }
        } else {
            if (!data?.FirstName?.trim()) {
                ctx.addIssue({
                    path: ['FirstName'],
                    message: 'First name is required',
                    code: z.ZodIssueCode.custom
                });
            }

            if (!data?.LastName?.trim()) {
                ctx.addIssue({
                    path: ['LastName'],
                    message: 'Last name is required',
                    code: z.ZodIssueCode.custom
                });
            }
        }
    });
